
import React from 'react';
import {Search as SearchIcon} from "../../funcs/utils";

const on_change = component => ev => {
  component.updateSearch(ev.target.value);
}

const Search = props => {

  const container_style = {
    display: "flex",
  }
  const input_style = {
    width: "100%",
    border: "none",
    outline: "none",
    ':focus': {
      outline: "none",
      border: "none",
    },
    fontSize: "1.1rem",
    fontWeight: "bold",
  }
  const component = props.component;

  return (
    <div style={container_style}>
      <div><SearchIcon/></div>
      <div style={{width: "0.5rem"}}/>
      <div><input
        value={component.state.search}
        placeholder={"Search"}
        onChange={on_change(component)}
        style={input_style}/></div>
    </div>
  )
}

export { Search };
